import type { CageHealthOverviewResponseDto } from '@/services/types';

import type { CageHealthOverview, CageHealthParameter } from './types';

export function mapCageHealthOverviewToDomain(
    dto: CageHealthOverviewResponseDto
): CageHealthOverview {
    return {
        lastMeasurement: dto.lastMeasurement ?? null,
        parameters: (dto.parameters ?? []).map(mapParameter),
    };
}

function mapParameter(
    parameter: NonNullable<CageHealthOverviewResponseDto['parameters']>[number]
): CageHealthParameter {
    return {
        key: parameter.key,
        scores: {
            score0: parameter.scores?.score0 ?? null,
            score1: parameter.scores?.score1 ?? null,
            score2: parameter.scores?.score2 ?? null,
            score3: parameter.scores?.score3 ?? null,
        },
        alert: {
            level: parameter.alert.level,
            priority: parameter.alert.priority,
        },
    };
}
